export default "/assets/images/filter-HW.77bfac0d65f7cbc8.png";